/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./forwardToThirdParty.vue?vue&type=template&id=4ba47cdc&scoped=true"
import script from "./forwardToThirdParty.vue?vue&type=script&lang=js"
export * from "./forwardToThirdParty.vue?vue&type=script&lang=js"
import style0 from "./forwardToThirdParty.vue?vue&type=style&index=0&id=4ba47cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba47cdc",
  null
  
)

export default component.exports